import React from 'react';
import { HelpCircle } from 'lucide-react';
import { faqData } from '../../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

const FAQSection = () => {
  return (
    <section id="faq" className="py-16 sm:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-12">
          <div className="inline-flex items-center gap-2 bg-[var(--brand-teal-50)] border border-[var(--brand-teal-100)] rounded-full px-4 py-2 mb-5">
            <HelpCircle className="w-4 h-4 text-[var(--brand-teal-600)]" />
            <span className="text-sm font-medium text-[var(--brand-teal-700)]">FAQ</span>
          </div>
          <h2 className="heading-1 mb-4">Frequently Asked Questions</h2>
          <p className="body-large">
            Everything you need to know about SuperHunt and how it can transform 
            your prospecting workflow.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-3 sm:space-y-4">
          {faqData.map((faq, index) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="bg-gradient-to-r from-[var(--brand-teal-50)]/50 to-white rounded-xl sm:rounded-2xl border border-[var(--brand-teal-100)] px-4 sm:px-6 data-[state=open]:shadow-lg data-[state=open]:border-[var(--brand-teal-200)] transition-all"
            >
              <AccordionTrigger className="py-4 sm:py-5 hover:no-underline group">
                <div className="flex items-start gap-3 sm:gap-4 text-left">
                  <span className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-[var(--brand-teal-100)] flex items-center justify-center flex-shrink-0 text-xs sm:text-sm font-bold text-[var(--brand-teal-700)] group-data-[state=open]:bg-[var(--brand-teal-600)] group-data-[state=open]:text-white transition-colors">
                    {index + 1}
                  </span>
                  <span className="heading-3 text-sm sm:text-base font-medium pr-4">
                    {faq.question}
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="pb-4 sm:pb-5 pl-10 sm:pl-12">
                <p className="body-medium text-sm sm:text-base leading-relaxed">{faq.answer}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
